module.exports = __webpack_public_path__ + "img/Dashboard.d461a2ae.png";